import React from 'react';
import PropTypes from 'prop-types';

function MDSubtitleText({ title, className, textColor, textAlign, fontWeight, style }) {
  return (
    <div className={`${className}`}>
      <p
        className={`md-subtitle-text ${fontWeight} text-xl sm:text-2xl ${textColor} ${textAlign} letter-spacing-1 leading-6`}
        style={style}
      >
        {title}
      </p>
    </div>
  );
}

export default MDSubtitleText;

MDSubtitleText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string,
  fontWeight: PropTypes.string,
  style: PropTypes.any
};

MDSubtitleText.defaultProps = {
  textColor: 'text-gray-500',
  textAlign: 'text-left',
  fontWeight: 'text-light'
};
